import { useQuery } from '@tanstack/react-query'
import qs from 'qs'
import { isDefined } from 'utils/type-guard/isDefined'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { throwIfApiError } from '@omnea-app/legacy/utils/error-handling/throwifApiError'
import { AuditLogApiClient, AuditLogQueryParams } from '@omnea-app/packages/universal/auditLogApiClient/auditLogApiClient'

export const requestAuditLogQueryKey = 'audit-log-request'

export const getAuditLogsByRequestId = async (token: string, requestId: string, queryParams: GetAuditLogListQueryParams) => {
  const client = new AuditLogApiClient({ authorization: token })
  const { data, error } = await client.GET('/audit-log/request-id/{requestId}', {
    params: {
      query: queryParams,
      path: { requestId },
    },
    querySerializer: (params) => qs.stringify(params),
  })
  throwIfApiError(error)

  return { ...data, hasNextPage: isDefined(data.nextCursor), totalCount: -1 }
}
export type GetAuditLogListQueryParams = AuditLogQueryParams<'/audit-log/request-id/{requestId}', 'get'>

export const useGetAuditLogListByRequestId = ({
  requestId,
  queryParams,
}: {
  requestId: string
  queryParams: GetAuditLogListQueryParams
}) => {
  const { getToken } = useAuthenticatedUser()

  return useQuery({
    queryKey: [requestAuditLogQueryKey, requestId, JSON.stringify(queryParams)],
    queryFn: async () => getAuditLogsByRequestId(await getToken(), requestId, queryParams),
  })
}
